/**
 * Push notifications for Matbakhi on Capacitor native shells.
 * No-op on the web (web push needs a separate VAPID + service worker flow).
 *
 * On first launch we:
 *   - request the permission
 *   - register with FCM/APNs
 *   - log the device token (you should POST it to your backend so you can target
 *     this user for daily-log reminders, trial expiry warnings, etc.)
 *
 * Required native config (see MOBILE_BUILD_GUIDE.md):
 *   - Android: google-services.json from your Firebase project, dropped into
 *     android/app/, plus the Google Services Gradle plugin (auto-wired by Capacitor).
 *   - iOS: GoogleService-Info.plist from Firebase + Push capability + APNs key in
 *     the Apple developer portal (Capacitor template includes the entitlements).
 */
import { Capacitor } from '@capacitor/core';
import { api } from './api';

let initialized = false;

export async function initPush() {
  if (initialized) return;
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { PushNotifications } = await import('@capacitor/push-notifications');
    const perm = await PushNotifications.checkPermissions();
    let granted = perm.receive;
    if (granted !== 'granted') {
      const req = await PushNotifications.requestPermissions();
      granted = req.receive;
    }
    if (granted !== 'granted') return;

    await PushNotifications.register();

    PushNotifications.addListener('registration', async (token) => {
      console.log('[Push] token', token.value);
      try {
        const sk = localStorage.getItem('push_token');
        if (sk !== token.value) localStorage.setItem('push_token', token.value);
      } catch (err) { console.warn('[Push] persist token failed', err); }
      try {
        await api.post('/push/register', {
          token: token.value,
          platform: Capacitor.getPlatform(),
          device_info: {
            ua: typeof navigator !== 'undefined' ? navigator.userAgent : '',
          },
        });
      } catch (err) { console.warn('[Push] backend register failed', err); }
    });

    PushNotifications.addListener('registrationError', (err) => {
      console.warn('[Push] register error', err);
    });

    PushNotifications.addListener('pushNotificationReceived', (notif) => {
      console.log('[Push] received', notif);
    });

    PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
      const route = action?.notification?.data?.route;
      if (route && typeof window !== 'undefined') {
        window.location.assign(route);
      }
    });

    initialized = true;
  } catch (e) {
    console.warn('[Push] init failed', e);
  }
}
